export default "__VITE_ASSET__jXXOh5jv__"